type Props = {
  title?: React.ReactNode;
  message?: React.ReactNode;
  action?: React.ReactNode;
};

export const EmptyState = ({ title = 'Nothing here yet', message, action }: Props) => (
  <div className="flex h-48 flex-col items-center justify-center rounded-md border border-dashed p-6 text-center" data-testid="empty-state">
    <p className="text-base font-medium">{title}</p>
    {message && <p className="mt-1 max-w-md text-sm text-muted-foreground">{message}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
